import { useCallback, useEffect, useState } from 'react';
import { Client } from 'types/clients';
import { getClients } from 'services/clients';
import { useAsyncCallback } from 'hooks/useAsyncCallback';
import { useUpdateSearchParamUrl } from 'hooks/hook';
import { SIZE_CLIENTS_PAGE } from 'const/paging';
import { isNil, omitBy } from 'lodash';
import { useNavigate } from 'react-router-dom';
export const HEADER_CLIENTS = [
  { label: 'Client Name', sort: 'clientName' },
  // { label: 'Client Email', sort: 'clientEmail' },
  // { label: 'Contact Person', sort: 'contactPerson' },
  { label: 'Actions', width: 400 }
];

export const useInjection = () => {
  const navigate = useNavigate();
  const [clients, setClients] = useState<Client[]>([]);
  const [searchParams, setSearchParams] = useUpdateSearchParamUrl();
  const [page, setPage] = useState<number>(1);
  const [hasMore, setHasMore] = useState<boolean>(true);

  const handleGetInitClients = useCallback(async () => {
    const params = {
      size: SIZE_CLIENTS_PAGE,
      page: 1,
      keyword: searchParams.get('searchText') || undefined,
      orderBy: searchParams.get('sortBy') || undefined,
      order: searchParams.get('order') || undefined,
      type: searchParams.get('type') || undefined
    };
    const data = await getClients(params);
    setClients(data.clients);
    const element = document.getElementById('id-table-clients');
    if (element) {
      element.scrollTo({ top: 0, behavior: 'smooth' });
    }
    if (data.total > SIZE_CLIENTS_PAGE) {
      setPage(2);
      setHasMore(true);
      return;
    }
    setHasMore(false);
  }, [searchParams]);

  const fetchMoreData = useCallback(async () => {
    const params = {
      size: SIZE_CLIENTS_PAGE,
      page: page,
      keyword: searchParams.get('searchText') || undefined,
      orderBy: searchParams.get('sortBy') || undefined,
      order: searchParams.get('order') || undefined,
      type: searchParams.get('type') || undefined
    };
    const data = await getClients(params);
    setClients((prevState) => [...prevState, ...data.clients]);
    if (data.total > SIZE_CLIENTS_PAGE * page) {
      setPage((prevState) => prevState + 1);
      setHasMore(true);
      return;
    }
    setHasMore(false);
  }, [page, searchParams]);
  const { asyncCallback: asyncGetInitClients } = useAsyncCallback(handleGetInitClients, []);

  const handleSearch = useCallback((searchText: string) => {
    setSearchParams(omitBy({ searchText }, isNil) as { [key: string]: string });
  }, []);

  const filterByTypeAccess = useCallback((type: string) => {
    setSearchParams(omitBy({ type }, isNil) as { [key: string]: string });
  }, []);

  useEffect(() => {
    asyncGetInitClients();
  }, [asyncGetInitClients]);

  const onSortHeader = useCallback(
    (sortField: string) => {
      let order = 'asc';
      const sortFieldOld = searchParams.get('sortBy');
      const orderOld = searchParams.get('order');
      if (sortFieldOld === sortField) {
        if (orderOld === 'asc') {
          order = 'desc';
        } else {
          order = 'asc';
        }
      }
      setSearchParams(
        omitBy({ sortBy: sortField, order: order }, isNil) as { [key: string]: string }
      );
    },
    [searchParams, setSearchParams]
  );

  const onClickAction = useCallback(
    (href: string) => {
      navigate(href);
    },
    [navigate]
  );

  return {
    clients,
    setClients,
    fetchMoreData,
    hasMore,
    handleSearch,
    onSortHeader,
    filterByTypeAccess,
    searchParams,
    onClickAction
  };
};
